<template>
  <ion-app>
    <ion-router-outlet />
    <ion-progress-bar v-show="store.isProgressing" type="indeterminate" color="danger"></ion-progress-bar>
  </ion-app>
</template>

<script setup>
import { useStore } from '@/state/state';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
const store = useStore();
</script>
